export default {
  "kFactor.title": "K-Factor",
  "kFactor.column.no": "#序号",
  "kFactor.column.statisticsTime": "日期",
  "kFactor.column.registerNum": "注册总数",
  "kFactor.column.inviteNum": "被邀请注册数",
  "kFactor.column.inviteActiveNum": "激活数",
  "kFactor.column.inviteAvg": "i(人均邀请)",
  "kFactor.column.activeRatio": "c(激活率)",
  "kFactor.search.statisticsTime": "日期",
  "kFactor.column.inviteDepositNum": "邀请存款数量",
  "kFactor.column.firstDepositNum": "首次存款金额",
};